import React from 'react';

// Sin esto, cualquier error al pintar desmonta toda la app y deja la pagina
// completamente en blanco, sin mensaje. Se muestra un aviso con opcion de
// recargar y el error queda en la consola (F12) para poder diagnosticarlo.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Error al mostrar la interfaz:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          maxWidth: 480,
          margin: '48px auto',
          padding: 24,
          textAlign: 'center',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
          fontFamily: 'inherit',
        }}
      >
        <h3 style={{ marginTop: 0 }}>Ocurrió un error al mostrar esta sección</h3>
        <p>Recarga la página para continuar. Si el problema se repite, avísale al administrador.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: 8,
            background: '#1e3a5f',
            color: '#fff',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Recargar
        </button>
      </div>
    );
  }
}
